import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromOrganization from '../redux/organization.reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromOrganization.organizationFeatureKey,
      fromOrganization.reducer
    ),
  ],
})
export class OrganizationModule {}
